import { GET_ALL_CONTACT } from "./actions";

const initialState = {
  contactList: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },

  loading: true,
};

const contactReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ALL_CONTACT:
      return {
        ...state,
        loading: false,
        contactList: payload,
      };

    default:
      return state;
  }
};

export default contactReducer;
